import { render, staticRenderFns } from "./studentAvatar.vue?vue&type=template&id=3c128fd5&"
import script from "./studentAvatar.vue?vue&type=script&lang=ts&"
export * from "./studentAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports